import { useContext } from 'react';
import { Page, PageContentList } from 'shared/_components/page/styles';
import { Box } from '@mui/material';
import PageHeader from 'shared/_components/page/page-header';
import { UserContext } from 'shared/Providers/User';
import UserCard from 'shared/_pages/account/user-card';
import UserStatsCard from 'shared/_pages/account/user-stats-card';
import UserPreferencesCard from 'shared/_pages/account/user-preferences-card';

export default function AccountPage() {
	const { user } = useContext(UserContext);

	return (
		<Page sx={{ bgcolor: '#f8fafc' }}>
			<PageHeader breadcrumbs={['Account']}>{user?.name}</PageHeader>
			<PageContentList>
				<Box
					display="flex"
					gap={6}
					sx={(theme) => ({
						display: 'grid',
						gridTemplateColumns: '1fr',
						gap: theme.spacing(6),
						marginBottom: theme.spacing(8),
						[theme.breakpoints.up('md')]: {
							gridTemplateColumns: '1fr 1fr',
						},
					})}
				>
					<UserCard />
					<UserStatsCard />
					<UserPreferencesCard />
				</Box>
			</PageContentList>
		</Page>
	);
}
